import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import { IState } from '@/store/modules/transco-hyper-proxi/types'

const state: IState = {
  isLoading: false,
  isCreated: false,
  isModified: false,
  isDeleted: false,
  transcoHyperProxi: [],
  transcoHyperProxiProduct: [],
  areTranscosLoaded: false,
  areTranscosProductsLoaded: false,
  providerSearch: '',
  productSearch: '',
}

export default {
  state,
  actions,
  getters,
  mutations,
}
